<div class="flex justify-center items-center bg-gray-100 p-40">
  <div
    class="p-6 bg-white rounded-md shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] inline-flex flex-col justify-center items-center gap-6">
    <div data-color="Green"
         data-dark-mode="False"
         data-size="lg"
         data-type="Circle"
         class="w-12 h-12 bg-green-100 rounded-full inline-flex justify-center items-center">
      <svg class="w-6 h-6 text-gray-800"
           aria-hidden="true"
           xmlns="http://www.w3.org/2000/svg"
           width="24"
           height="24"
           fill="none"
           viewBox="0 0 24 24">
        <path stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 11.917 9.724 16.5 19 7.5"/>
      </svg>

    </div>
    <div class="self-stretch flex flex-col justify-start items-center gap-1">
        <div class="justify-start text-gray-900 text-2xl font-bold font-['Inter'] leading-loose">Sua conta foi criada com sucesso!</div>
        <div class="self-stretch text-center justify-start text-gray-500 text-base font-normal font-['Inter'] leading-normal">Clique abaixo para continuar o acesso.</div>
    </div>
    <div class="">
        <a class="self-stretch  inline-flex justify-center items-center gap-3" href="/login">
          <svg class="w-6 h-6 text-gray-800"
               aria-hidden="true"
               xmlns="http://www.w3.org/2000/svg"
               width="24"
               height="24"
               fill="none"
               viewBox="0 0 24 24">
            <path stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 12h14M5 12l4-4m-4 4 4 4"/>
          </svg>
          <div class="text-center justify-start text-gray-900 text-sm font-medium font-['Inter'] leading-tight">Fazer login</div>
        </a>
    </div>
</div>
</div>
